document.addEventListener('DOMContentLoaded', function() {
  
  // ========================================
  // UTILITY FUNCTIONS
  // ========================================
  
  const Utils = {
    // Safe query helper - consolidates repetitive null checks
    // Usage: Utils.safeQuery(root, selector, callback)
    safeQuery: (root, selector, callback) => {
      try {
        if (!root || !selector) return;
        const elements = root.querySelectorAll(selector);
        elements.forEach(el => {
          if (el && callback) {
            callback(el);
          }
        });
      } catch (e) {
        // Only log non-ResizeObserver errors (ResizeObserver loop limit is expected)
        if (!e.message || !e.message.includes('ResizeObserver loop limit')) {
          console.warn(`[Custom] Query failed for selector "${selector}":`, e);
        }
      }
    },

    // Safe execute wrapper - DRY up try-catch blocks
    // Usage: Utils.safeExecute(() => { /* code */ }, 'Operation name', { logErrors: true, fallback: () => {} })
    safeExecute: (fn, operationName = 'Operation', options = {}) => {
      const {
        logErrors = true,
        fallback = null,
        suppressKnownErrors = true
      } = options;

      try {
        return fn();
      } catch (error) {
        // Whitelist of known safe-to-ignore errors
        const knownErrors = [
          'ResizeObserver loop limit',
          'ResizeObserver loop completed',
          'Non-Error promise rejection'
        ];

        const isKnownError = suppressKnownErrors && 
          knownErrors.some(msg => error.message && error.message.includes(msg));

        if (!isKnownError && logErrors) {
          console.error(`[Custom] ${operationName} failed:`, {
            message: error.message,
            stack: error.stack,
            error: error
          });
        }

        if (fallback && typeof fallback === 'function') {
          return fallback(error);
        }

        // Re-throw if no fallback and not a known error
        if (!isKnownError) {
          throw error;
        }
      }
    }
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const headerSidebarBanner = entry.target;
        initializeHeaderSidebarSwiper(headerSidebarBanner);
        headerSidebarBanner.style.cursor = 'pointer';
        headerSidebarBanner.classList.add('custom-header-sidebar-banner');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px'
  });
  
  function initializeHeaderSidebarSwiper(bannerElement) {
    Utils.safeQuery(bannerElement, '.header-sidebar__banner-swiper', (swiperContainer) => {
      if (typeof Swiper !== 'undefined') {
        new Swiper('.header-sidebar__banner-swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoHeight: true,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets'
          }
        });
      }
    });
  }
  
  function observeHeaderSidebarBanners() {
    Utils.safeQuery(document, 'header-sidebar-banner', (banner) => {
      observer.observe(banner);
    });
  }
  
  observeHeaderSidebarBanners();
  
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'HEADER-SIDEBAR-BANNER') {
            observer.observe(node);
          }
          
          // Use safeQuery for nested banners
          Utils.safeQuery(node, 'header-sidebar-banner', (banner) => {
            observer.observe(banner);
          });
        }
      });
    });
  });
  
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  function initHeaderSidebarScrollDetection() {
    const headerSidebar = document.getElementById('sidebar-menu');
    if (!headerSidebar) return;

    let isScrolled = false;

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shadowRoot = headerSidebar.shadowRoot;
      
      if (!shadowRoot) return;
      
      if (scrollTop > 0 && !isScrolled) {
        // Use safeQuery to consolidate null checks
        Utils.safeQuery(shadowRoot, '[part="overlay"], [part="content"]', (el) => {
          el.classList.add('header-scrolled');
        });
        isScrolled = true;
      } else if (scrollTop === 0 && isScrolled) {
        // Use safeQuery to consolidate null checks
        Utils.safeQuery(shadowRoot, '[part="overlay"], [part="content"]', (el) => {
          el.classList.remove('header-scrolled');
        });
        isScrolled = false;
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    handleScroll();
  }

  initHeaderSidebarScrollDetection();

  // Gorgias Chat positioning for product pages
  if (document.body.classList.contains('template-product')) {
    const gorgiasObserver = new MutationObserver(() => {
      Utils.safeExecute(() => {
        if (typeof GorgiasChat !== 'undefined' && GorgiasChat.setPosition) {
          GorgiasChat.setPosition({ offsetY: 100, offsetX: 0, alignment: 'bottom-right' });
          gorgiasObserver.disconnect();
        }
      }, 'Gorgias Chat positioning', { logErrors: true });
    });
    gorgiasObserver.observe(document.body, { childList: true, subtree: true });
  }
});
